// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3AFDJ","title":"AfterFrontImage_title__37qlN"};